import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';

const { routes } = AppConfig;

export const nonProductionGuard: () => boolean | UrlTree = () => {
  const router = inject(Router);
  const environment = inject(ENVIRONMENT_PROVIDER);

  if (environment.production) {
    return router.parseUrl('/' + routes.error404);
  }

  return true;
};
